module.exports = __webpack_public_path__ + "static/IMG_0094-9403e3c2a81e10a1893be71f2b69c496.jpg";